import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SignInForm } from "./components/SignInForm";
import { Dashboard } from "./components/Dashboard";
import { LandingPage } from "./components/LandingPage";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = () => {
    // здесь можно вызвать API, проверить логин/пароль
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  return (
    <Router>
      <Routes>
        {/* главная страница */}
        <Route path="/" element={<LandingPage />} />

        {/* страница с промокодами */}
        <Route
          path="/promos"
          element={
            <>
              {isLoggedIn ? (
                <Dashboard onLogout={handleLogout} />
              ) : (
                <SignInForm onLogin={handleLogin} />
              )}
            </>
          }
        />

        {/* 404 */}
        <Route path="*" element={<h1>404 — страница не найдена</h1>} />
      </Routes>
    </Router>
  );
}

export default App;
